import moment from 'moment';

export const stringDateSort = (rowA, rowB, columnId) => {
  const rawA = rowA.original[columnId];
  const rawB = rowB.original[columnId];
  const dateA = rawA ? moment(rawA).toDate() : new Date(0);
  const dateB = rawB ? moment(rawB).toDate() : new Date(0);

  return dateA - dateB;
};